'use client'

import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import { createInterval } from '@components/MainWidget/ChallanWidgetModals/utils'
import styles from './loaderScreen.module.scss'

const LoaderScreen = ({ screens, duration, onComplete }) => {
  const [currentScreenIndex, setCurrentScreenIndex] = useState<number>(0)

  useEffect(() => {
    const cleanup = createInterval(setCurrentScreenIndex, duration, onComplete, screens.length)

    return cleanup
  }, [screens, duration, onComplete])

  const currentScreen = screens[currentScreenIndex]

  return (
    <div className={styles.loaderScreen}>
      <Image src={currentScreen.icon} alt={currentScreen.alt} width={100} height={100} priority />
      <p className={styles.loaderText}>{currentScreen.text}</p>
    </div>
  )
}

export default LoaderScreen
